/**
 * 사용자 행동 트래킹 헬퍼 — React 클라이언트
 *
 * 사용법:
 *   import { trackPageview, trackEvent } from '../util/track';
 *   trackPageview('/map');                              // 페이지뷰 (App.js의 location 변경 useEffect에서 자동 호출)
 *   trackEvent('BOOKMARK_ADD', { landName: '...' });    // 임의 이벤트
 *
 * 백엔드: POST /api/track  (server/routes/api.js)
 */

import axios from 'axios';

const TRACK_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/track`;

// 같은 path 연속 호출은 1초 내 중복 무시 (StrictMode 이중 렌더 / 빠른 라우트 전환 대비)
let lastPath = null;
let lastAt = 0;
const DEDUP_MS = 1000;

function send(payload) {
  if (!process.env.REACT_APP_BACKEND_SERVER) return; // 환경변수 없으면 조용히 스킵
  axios
    .post(TRACK_URL, payload, { withCredentials: true, timeout: 5000 })
    .catch(() => {
      // 트래킹은 실패해도 사용자 경험 절대 방해 X
    });
}

export function trackPageview(path) {
  if (!path) return;
  const fullPath = path + (window.location.search || '');
  const now = Date.now();
  if (fullPath === lastPath && now - lastAt < DEDUP_MS) return;
  lastPath = fullPath;
  lastAt = now;
  send({ type: 'PAGEVIEW', path: fullPath });
}

export function trackEvent(type, extra = {}) {
  if (!type) return;
  let path = window.location.pathname || '';
  // extra 데이터는 path 끝에 query string으로 직렬화 (EventLog에 별도 컬럼 추가 없이 보존)
  const keys = Object.keys(extra);
  if (keys.length > 0) {
    const qs = keys
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(String(extra[k]).slice(0, 100))}`)
      .join('&');
    path = `${path}#evt?${qs}`;
  }
  send({ type, path });
}
